<div class="row survey-detail-content">
  <div class="survey-content-boxes">
    <h6 class="text-center">FIELDED VS. GOAL</h6>
    <p>{{ survey.fielded | number }} | {{ survey.goal | number }}</p>
    <div class="net-complete-box">
      <p class="text-center">
        Net of
        {{ survey.reconciliationCompleteCount + survey.manualFixCompltCount }}
        adjustments
        <span class="help-tip">
          <i class="fa fa-info-circle" aria-hidden="true"></i>
          <p>
            Net Number of completes that have been Manually Fixed: <br />
            {{ survey.manualFixCompltCount }} <br />Net Number of completes that
            have been Buyer Reconciled : <br />{{
              survey.reconciliationCompleteCount
            }}
          </p>
        </span>
      </p>
    </div>
  </div>
  <div class="survey-content-boxes">
    <h6
      class="text-center"
      *ngIf="userRole === 'buyer' || userRole === 'operator'"
    >
      TOTAL COST
    </h6>
    <h6 class="text-center" *ngIf="userRole === 'supplier'">TOTAL REVENUE</h6>
    <div class="survey-status">
      <button class="stats-menu-btn" [psUiDropdownToggleFor]="TotalCost">
        {{ survey.totalCostLabel }}
      </button>
      <ps-ui-dropdown class="status-dropdown" #TotalCost="psUiDropdown">
        <button
          *ngIf="userRole === 'buyer' || userRole === 'operator'"
          psUiDropdownItem
          (click)="
            survey.totalCostLabel = 'At Launch';
            survey.totalCostValue = survey.totalCost.launch
          "
        >
          At Launch
        </button>
        <button
          psUiDropdownItem
          (click)="
            survey.totalCostLabel = 'Projected';
            survey.totalCostValue = survey.totalCost.projected
          "
        >
          Projected
        </button>
        <button
          psUiDropdownItem
          (click)="
            survey.totalCostLabel = 'Current';
            survey.totalCostValue = survey.totalCost.current
          "
        >
          Current
        </button>
      </ps-ui-dropdown>
    </div>
    <span>{{ survey.totalCostValue | currency : survey.currencySymbol }}</span>
  </div>
  <div class="survey-content-boxes cpi-box">
    <h6 class="text-center">CPI</h6>
    <div class="survey-status">
      <button class="stats-menu-btn" [psUiDropdownToggleFor]="Cpi">
        {{ survey.cpi1Label }}
      </button>
      <ps-ui-dropdown class="status-dropdown" #Cpi="psUiDropdown">
        <button
          *ngIf="userRole === 'buyer' || userRole === 'operator'"
          psUiDropdownItem
          (click)="
            survey.cpi1Label = 'Projected';
            survey.cpi1Value = survey.cpi.projected
          "
        >
          Projected
        </button>
        <button
          psUiDropdownItem
          (click)="
            survey.cpi1Label = 'At Launch'; survey.cpi1Value = survey.cpi.launch
          "
        >
          At Launch
        </button>
        <button
          psUiDropdownItem
          (click)="
            survey.cpi1Label = 'Current'; survey.cpi1Value = survey.cpi.current
          "
        >
          Current
        </button>
        <button
          psUiDropdownItem
          (click)="
            survey.cpi1Label = 'Average';
            survey.cpi1Value = survey.cpi.averageCpi
          "
        >
          Average
        </button>
      </ps-ui-dropdown>
    </div>
    <div class="survey-status">|</div>
    <div class="survey-status">
      <button class="stats-menu-btn" [psUiDropdownToggleFor]="Acpi">
        {{ survey.cpi2Label }}
      </button>
      <ps-ui-dropdown class="status-dropdown" #Acpi="psUiDropdown">
        <button
          psUiDropdownItem
          (click)="
            survey.cpi2Label = 'At Launch'; survey.cpi2Value = survey.cpi.launch
          "
        >
          At Launch
        </button>
        <button
          *ngIf="userRole === 'buyer' || userRole === 'operator'"
          psUiDropdownItem
          (click)="
            survey.cpi2Label = 'Projected';
            survey.cpi2Value = survey.cpi.projected
          "
        >
          Projected
        </button>
        <button
          psUiDropdownItem
          (click)="
            survey.cpi2Label = 'Current'; survey.cpi2Value = survey.cpi.current
          "
        >
          Current
        </button>
        <button
          psUiDropdownItem
          (click)="
            survey.cpi2Label = 'Average';
            survey.cpi2Value = survey.cpi.averageACpi
          "
        >
          Average
        </button>
      </ps-ui-dropdown>
    </div>
    <div class="div-flex-center">
      <div class="survey-status w-80">
        <span>{{
          survey.cpi1Label === 'Current' && survey.is_qbp_enable
            ? 'QBP'
            : (survey.cpi1Value | currency : survey.currencySymbol)
        }}</span>
      </div>
      <div class="survey-status">|</div>
      <div class="survey-status w-80">
        <span>{{
          survey.cpi2Label === 'Current' && survey.is_qbp_enable
            ? 'QBP'
            : (survey.cpi2Value | currency : survey.currencySymbol)
        }}</span>
      </div>
    </div>
  </div>
  <div class="survey-content-boxes">
    <h6 class="text-center">LOI</h6>
    <div class="survey-status">
      <button class="stats-menu-btn" [psUiDropdownToggleFor]="Loi">
        {{ survey.loiLabel }}
      </button>
      <ps-ui-dropdown class="status-dropdown" #Loi="psUiDropdown">
        <button
          psUiDropdownItem
          (click)="
            survey.loiLabel = 'At Launch'; survey.loiValue = survey.loi.launch
          "
        >
          At Launch
        </button>
        <button
          psUiDropdownItem
          (click)="
            survey.loiLabel = 'Overall'; survey.loiValue = survey.loi.overall
          "
        >
          Overall
        </button>
        <button
          psUiDropdownItem
          (click)="
            survey.loiLabel = 'Recent'; survey.loiValue = survey.loi.recent
          "
        >
          Recent
        </button>
      </ps-ui-dropdown>
    </div>
    <span>{{ survey.loiValue }} mins</span>
  </div>
  <div class="survey-content-boxes">
    <h6 class="text-center">INCIDENCE</h6>
    <div class="survey-status">
      <button class="stats-menu-btn" [psUiDropdownToggleFor]="Incidence">
        {{ survey.incidenceLabel }}
      </button>
      <ps-ui-dropdown class="status-dropdown" #Incidence="psUiDropdown">
        <button
          psUiDropdownItem
          (click)="
            survey.incidenceLabel = 'At Launch';
            survey.incidenceValue = survey.incidence.launch
          "
        >
          At Launch
        </button>
        <button
          psUiDropdownItem
          (click)="
            survey.incidenceLabel = 'Overall';
            survey.incidenceValue = survey.incidence.overall
          "
        >
          Overall
        </button>
        <button
          psUiDropdownItem
          (click)="
            survey.incidenceLabel = 'Recent';
            survey.incidenceValue = survey.incidence.recent
          "
        >
          Recent
        </button>
      </ps-ui-dropdown>
    </div>
    <span>{{ survey.incidenceValue }} %</span>
  </div>
</div>
